import { Button, Typography, Container, Stack, TextField } from '@mui/material';
const AuthPage = ({
  needsBootstrap,
  bootstrapUser,
  canDevReset,
  authForm,
  setAuthForm,
  onSubmit,
  loading,
  message,
}) => {
  return (
    <Container
      dir="rtl"
      sx={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        padding: '16px',
        position: 'relative',
        overflow: 'hidden',
        background: 'linear-gradient(145deg, #f4f0e9 0%, #eaf2ff 48%, #ddebff 100%)',
        '&::before': {
          content: '""',
          position: 'absolute',
          borderRadius: '50%',
          filter: 'blur(2px)',
          width: '520px',
          height: '520px',
          top: '-260px',
          right: '-120px',
          background: 'rgba(22,119,255,.14)',
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          borderRadius: '50%',
          filter: 'blur(2px)',
          width: '380px',
          height: '380px',
          bottom: '-220px',
          left: '-80px',
          background: 'rgba(22,119,255,.09)',
        },
      }}
    >
      <Stack
        sx={(theme) => ({
          width: 'min(480px, 100%)',
          background: 'var(--panel)',
          border: '1px solid rgba(20,45,41,.1)',
          borderRadius: '24px',
          padding: '42px',
          boxShadow: '0 28px 80px rgba(17,39,35,.16)',
          textAlign: 'right',
          position: 'relative',
          zIndex: '1',
          [theme.breakpoints.down('sm')]: {
            padding: '28px 22px',
            borderRadius: '20px',
          },
        })}
      >
        <Stack
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            marginBottom: '34px',
            color: '#15211f',
            fontSize: '21px',
            fontWeight: '900',
          }}
        >
          <Typography
            sx={(theme) => ({
              width: '38px',
              height: '38px',
              display: 'inline-grid',
              placeItems: 'center',
              flex: '0 0 auto',
              borderRadius: '12px',
              color: 'white',
              background: 'linear-gradient(135deg, #2888ff, #1269e8)',
              boxShadow: '0 8px 24px rgba(22,119,255,.24)',
              fontSize: '18px',
              fontWeight: '900',
              [theme.breakpoints.down('lg')]: {
                width: '36px',
                height: '36px',
                borderRadius: '11px',
              },
            })}
          >
            L
          </Typography>
          <Typography>Calmpi</Typography>
        </Stack>
        <Typography
          sx={{
            margin: '0 0 8px',
            color: 'var(--primary)',
            fontSize: '12px',
            fontWeight: '800',
            letterSpacing: '0',
            textTransform: 'uppercase',
            marginBottom: '9px',
          }}
        >
          מרכז הבקרה
        </Typography>
        <Typography
          sx={{
            fontSize: 20,
            fontWeight: 'bold',
          }}
        >
          {needsBootstrap ? 'יצירת משתמש מערכת ראשון' : 'כניסה לפאנל'}
        </Typography>
        <Typography
          sx={{
            margin: '10px 0 0',
            color: 'var(--muted)',
            lineHeight: '1.65',
          }}
        >
          כל מה שצריך לניהול המקומות, המשתמשים והפעילות - במקום אחד.
        </Typography>
        <Stack
          onSubmit={onSubmit}
          sx={{
            display: 'grid',
            gap: '18px',
            marginTop: '26px',
            '& button': {
              minHeight: '48px',
              marginTop: '4px',
              background: 'linear-gradient(135deg, #2888ff, #1269e8)',
              boxShadow: '0 10px 24px rgba(22,119,255,.24)',
            },
            '& button:hover': {
              boxShadow: '0 13px 28px rgba(22,119,255,.32)',
              transform: 'translateY(-1px)',
            },
          }}
        >
          {needsBootstrap && (
            <Stack>
              שם
              <TextField
                value={authForm.name}
                onChange={(e) =>
                  setAuthForm({
                    ...authForm,
                    name: e.target.value,
                  })
                }
                required
                fullWidth
              />
            </Stack>
          )}
          <Stack>
            אימייל
            <TextField
              type="email"
              value={authForm.email}
              onChange={(e) =>
                setAuthForm({
                  ...authForm,
                  email: e.target.value,
                })
              }
              required
              fullWidth
            />
          </Stack>
          <Stack>
            סיסמה
            <TextField
              type="password"
              minLength={needsBootstrap || canDevReset ? 8 : undefined}
              value={authForm.password}
              onChange={(e) =>
                setAuthForm({
                  ...authForm,
                  password: e.target.value,
                })
              }
              required
              fullWidth
            />
          </Stack>
          {message && (
            <Typography
              sx={{
                borderColor: '#fecdca',
                background: '#fef3f2',
                color: 'var(--danger)',
                fontWeight: '700',
              }}
            >
              {message}
            </Typography>
          )}
          <Button onClick={onSubmit} disabled={loading}>
            {loading ? 'רגע...' : needsBootstrap ? 'יצירת אדמין' : 'כניסה'}
          </Button>
        </Stack>
      </Stack>
    </Container>
  );
};
export default AuthPage;
